export default class ActiveUserModel  {
    globalId: string = "";
    displayName: string = "";

    static from(json: string): ActiveUserModel {
        let model = Object.assign(new ActiveUserModel(), json);
        return model;
    }
}